import React from "react";
import ReferralPageSection from "../sections/ReferralPageSection/Content";
const ReferralPage = () => {
  return <ReferralPageSection />;
};

export default ReferralPage;
